/**
 * Sleep for a given number of milliseconds.
 *
 * @param ms A number of milliseconds to sleep.
 * @returns A promise that resolves after the given number of milliseconds.
 */
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Test if the code is running on the server.
 *
 * @returns A boolean indicating if the code is running on the server.
 */
export const isServer = () => !isClient();

/**
 * Test if the code is running on the client.
 *
 * @returns A boolean indicating if the code is running on the client.
 */
export const isClient = () => typeof document !== 'undefined';

/**
 * A util to test if the code is building or not.
 *
 * @returns A boolean indicating if the code is building.
 */
export const isBuilding = () => import.meta.env.VITE_BUILD_MODE === 'true';
